import { ROUTES } from '../../const/routes';
import BotonChico02 from '../Botones/BotonChico02/BotonChico02';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const location = useLocation();
  const { userData } = useUser();
  const { t } = useTranslation();

  const isCurrent = (path) => location.pathname.startsWith(path);
  const esAdmin = userData?.id_rol === 2;

  return (
    <nav className="bg-slate-950 py-2 md:py-3 border-y-4 border-slate-200 w-full">
      <div className="w-full px-2 md:px-4 xl:px-10">
        <div className="flex items-center gap-2 md:gap-4 w-full max-w-[1400px] mx-auto">
          <ul className="flex flex-wrap md:flex-nowrap justify-between items-center gap-2 md:gap-4 flex-1">
            <li className="w-full md:w-auto md:flex-1 text-center">
              <BotonChico02
                texto={t('navbar.games')}
                direccion={ROUTES.listaJuegos}
                bgColor="red"
                current={isCurrent('/juegos')}
              />
            </li>
            <li className="w-full md:w-auto md:flex-1 text-center">
              <BotonChico02
                texto={t('navbar.history')}
                direccion={ROUTES.historial}
                bgColor="green"
                current={isCurrent(ROUTES.historial)}
              />
            </li>
            <li className="w-full md:w-auto md:flex-1 text-center">
              <BotonChico02
                texto={t('navbar.balance')}
                direccion={ROUTES.listaCargaSaldo}
                bgColor="blue"
                current={isCurrent('/cargarSaldo')}
              />
            </li>
            <li className="w-full md:w-auto md:flex-1 text-center">
              <BotonChico02
                texto={t('navbar.ranking')}
                direccion={ROUTES.ranking}
                bgColor="yellow"
                current={isCurrent(ROUTES.ranking)}
              />
            </li>
            {esAdmin && (
              <li className="w-full md:w-auto md:flex-1 text-center">
                <BotonChico02
                  texto={t('navbar.admin')}
                  direccion={ROUTES.admin}
                  bgColor="purple"
                  current={isCurrent(ROUTES.admin)}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
